import { render } from "./detail.vue?vue&type=template&id=0ede778f&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0ede778f"

export default script